module.exports = __webpack_public_path__ + "img/hero-img-blog.24abad94.svg";